module.exports = __webpack_public_path__ + "static/img/clothing_05.df1124d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_05.png
// module id = VH37
// module chunks = 0